export default __webpack_public_path__ + "static/date-label-do-2-dark-8332e9f8e0a8679fbb611604924519f0af4aa5aa51f95c7a20159cd361adfa5a.png";